import _ from "lodash";
import { normalizeTransactionName } from "services/sentry/router";
import { match } from "react-router";

const getRouteName = () => {
  const { plainRoutes } = window;
  let routeName;
  normalizeTransactionName(plainRoutes, window.location, match, name => {
    routeName = name;
  });

  return routeName;
};

export const getExtensions = ({ request }) => {
  const extensions = _.get(request, "extensions", {});
  const { href } = window.location;
  const route = getRouteName();
  return {
    ...extensions,
    route,
    href,
  };
};
